import React, { createContext, PropsWithChildren, useReducer } from 'react';
import { ISurveyListFilter } from 'models';
import moment from 'moment';
import { YEAR_MONTH_DAY_SLASH } from '../utils';

export interface ISurveyListFilterContext {
	surveyListFilter: ISurveyListFilter;
	onChangeSurveyListFilter: (d: ISurveyListFilter) => void;
}

export const SurveyListFilterContext = createContext<ISurveyListFilterContext>({
	surveyListFilter: {},
	onChangeSurveyListFilter: () => {},
});

export const SurveyListFilterContextProvider = ({
	children,
}: PropsWithChildren<{}>) => {
	const [surveyListFilter, onChangeSurveyListFilter] = useReducer(
		(state: ISurveyListFilter, payload: ISurveyListFilter) => ({
			...state,
			...payload,
		}),
		{
			// startDate: moment().subtract(2, 'year').format(YEAR_MONTH_DAY_SLASH),
			startDate: '2019/01/01',
			endDate: moment().format(YEAR_MONTH_DAY_SLASH),
		},
	);

	return (
		<SurveyListFilterContext.Provider
			value={{
				surveyListFilter,
				onChangeSurveyListFilter,
			}}
		>
			{children}
		</SurveyListFilterContext.Provider>
	);
};
